<template>
  <div v-show="show" class="init-two">
    <div class="init-two-logo">
      <van-image v-if="radarBgImage" :src="radarBgImage" class="bg-image" alt="" fit="cover" />
      <van-icon v-else color="#ccc" size="100px" name="orders-o" />
      <div class="produce-radar radar" />
    </div>
    <div class="move-num">
      追溯中 <countTo :start-val="startVal" :end-val="endVal" :duration="3000" />%
    </div>
    <div class="produce-process">
      <transition v-for="(item, index) in tabList" :key="index" name="van-slide-up">
        <div v-show="item.show" class="process-item">
          <span>{{ item.name }}:</span> <span>{{ item.iconTxt }}</span> <svg-icon :icon-class="item.secIcon" class="titleIcon" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import { Loading } from 'vant'
let processTimer = null
export default {
  name: 'InitTwo',
  components: {
    [Loading.name]: Loading,
    countTo
  },
  props: {
    radarBgImage: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    },
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      processInterval: 500,
      startVal: 0,
      endVal: 100
    }
  },
  computed: {
    duration() {
      const count = this.tabList.length > 1 ? this.tabList.length - 1 : 2
      return this.processInterval * count
    }
  },
  mounted() {
    // 页面延时
    let count = 1
    processTimer = setInterval(() => {
      if (count > this.tabList.length) {
        this.$emit('update:show', false)
        clearInterval(processTimer)
      }
      if (count <= this.tabList.length) {
        this.tabList[count - 1].show = true
      }
      count++
    }, this.processInterval)
  }
}
</script>

<style rel="stylesheet/scss" lang="less" scoped>
  .flexStart() {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  @radarColor: rgba(82, 221, 135, 0.6);
  .radar {
    background: radial-gradient(rgba(32, 255, 77, 0.3) 0%, rgba(32, 255, 77, 0) 75%), repeating-radial-gradient(rgba(32, 255, 77, 0) 5.8%, rgba(32, 255, 77, 0) 18%, @radarColor 18.6%, rgba(32, 255, 77, 0) 18.9%), linear-gradient(90deg, rgba(32, 255, 77, 0) 49.5%, @radarColor 50%, @radarColor 50%, rgba(32, 255, 77, 0) 50.2%), linear-gradient(0deg, rgba(32, 255, 77, 0) 49.5%, @radarColor 50%, @radarColor 50%, rgba(32, 255, 77, 0) 50.2%);
    border-radius: 50%;
    border: 0.2rem solid @radarColor;
    overflow: hidden;
  }
  .radar:before {
    content: ' ';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: blips 5s infinite;
    animation-timing-function: linear;
    animation-delay: 1.4s;
  }
  .radar:after {
    content: ' ';
    display: block;
    background-image: linear-gradient(44deg, rgba(0, 255, 51, 0) 50%, #00ff33 100%);
    width: 50%;
    height: 50%;
    position: absolute;
    top: 0;
    left: 0;
    animation: radar-beam 5s infinite;
    animation-timing-function: linear;
    transform-origin: bottom right;
    border-radius: 100% 0 0 0;
  }

  @keyframes radar-beam {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes blips {
    14% {
      background: radial-gradient(2vmin circle at 75% 70%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%);
    }
    14.0002% {
      background: radial-gradient(2vmin circle at 75% 70%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%), radial-gradient(2vmin circle at 63% 72%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%);
    }
    25% {
      background: radial-gradient(2vmin circle at 75% 70%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%), radial-gradient(2vmin circle at 63% 72%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%), radial-gradient(2vmin circle at 56% 86%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%);
    }
    26% {
      background: radial-gradient(2vmin circle at 75% 70%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%), radial-gradient(2vmin circle at 63% 72%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%), radial-gradient(2vmin circle at 56% 86%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%);
      opacity: 1;
    }
    100% {
      background: radial-gradient(2vmin circle at 75% 70%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%), radial-gradient(2vmin circle at 63% 72%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%), radial-gradient(2vmin circle at 56% 86%, #ffffff 10%, @radarColor 30%, rgba(255, 255, 255, 0) 100%);
      opacity: 0;
    }
  }

  @keyframes scan {
    from {
      top: -667px;
    }/*网格移动到显示区域的外面*/
    to {
      top: 0;
    }
  }

  @-webkit-keyframes scan {
    from {
      top: -667px;
    }
    to {
      top: 0;
    }
  }

  .init-two{
    width: 100%;
    height: 100%;
    padding-top: 30%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }

  .init-two-logo{
    width: 180px;
    height: 180px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .bg-image{
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .produce-radar{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;left:0;
    }
  }
  .move-num{
    padding: 40px 0 20px;
  }
  .produce-process{
    @include flexStart();
    flex-direction: column;
    .process-item{
      font-size: 12px;
      color: #666;
      padding: 2px 0;
      span:nth-child(2){
        margin-left: 16px;
        margin-right: 4px;
      }
      span:nth-child(2), span:nth-child(3){
        color: #52dd87;
      }
      .titleIcon{
        color: #52dd87;
      }
    }

  }

</style>
